import { cpfInputMask, phoneInputMask } from "../../utils";
import { IClient } from "../../contexts/ClientsContext";
import {
  MaskFormItem,
  TextFormItem,
  SelectFormItem,
  SelectMultipleFormItem,
} from "../formItems";
import { IAuthState } from "../../contexts/AuthContext";
import {
  validationCpf,
  validationEmail,
  validationFullName,
  validationPhone,
} from "../../utils/formValidations";
import { Tooltip } from "antd";
import { AiFillInfoCircle } from "react-icons/ai";
import { assessorTooltip } from "../../pages/Professionals";

interface ClientFormItemProps {
  user: IAuthState;
  step?: number;
  assessores?: any;
  professionals?: any;
  client?: IClient | null;
  handleChangeAssessores?: any;
  onBlur?: any;
  userSelected?: any;
}

export const FormItemsClients = ({
  user,
  client,
  assessores,
  professionals,
  handleChangeAssessores,
  onBlur,
}: ClientFormItemProps) => {
  return {
    id: TextFormItem({
      name: "id",
      label: "Id",
      hidden: true,
      disabled: !!client,
    }),
    name: TextFormItem({
      name: "name",
      placeholder: "Nome",
      rules: validationFullName,
      disabled: false,
    }),
    username: MaskFormItem({
      name: "username",
      placeholder: "CPF",
      rules: validationCpf,
      mask: cpfInputMask,
      disabled: !!client,
    }),
    email: TextFormItem({
      name: "email",
      placeholder: "E-mail",
      rules: validationEmail,
      disabled: false,
      onBlur,
    }),
    phone: MaskFormItem({
      name: "phone",
      placeholder: "Celular",
      rules: validationPhone,
      mask: phoneInputMask,
      disabled: false,
      onBlur,
    }),
    plan: SelectFormItem({
      name: "plan",
      placeholder: "Plano",
      disabled: false,
      options: [
        {
          value: "free",
          label: "Gratuito",
          disabled: client?.hasPlanXp || client?.planType === "anual",
        },
        {
          value: "mensal",
          label: "Plano Premium mensal",
          disabled:
            !user.user?.liberadaContratacao ||
            client?.hasPlanXp ||
            client?.planType === "anual" ||
            client?.cancelRecuring,
        },
        {
          value: "anual",
          label: "Plano Premium anual",
          disabled: !user.user?.liberadaContratacao || client?.hasPlanXp,
        },
      ],
      onBlur,
    }),
    assessores: SelectMultipleFormItem({
      name: "assessores",
      placeholder: "Assessores",
      assessoresSelected: assessores,
      handleChangeAssessores: handleChangeAssessores,
      professionals,
      disabled: !user?.user?.office && !user?.user?.admin,
    }),
  };
};

export const FormItemsAssessores = (client?: IClient | null) => {
  return {
    id: TextFormItem({
      name: "id",
      label: "Id",
      hidden: true,
      disabled: !!client,
    }),
    name: TextFormItem({
      name: "name",
      placeholder: "Nome",
      rules: validationFullName,
      disabled: !!client,
    }),
    username: TextFormItem({
      name: "username",
      placeholder: "CPF",
      rules: validationCpf,
      disabled: !!client,
    }),
    email: TextFormItem({
      name: "email",
      placeholder: "E-mail",
      rules: validationEmail,
      disabled: false,
    }),
    acesso: SelectFormItem({
      name: "acesso",
      placeholder: "Selecione o tipo de acesso",
      label: (
        <>
          Acesso
          <Tooltip title={assessorTooltip}>
            <AiFillInfoCircle style={{ margin: "4px", minWidth: '30px' }} />
          </Tooltip>
        </>
      ),
      disabled: false,
      options: [
        {
          value: "admin",
          label: "Administrador",
        },
        {
          value: "gerente",
          label: "Gerente",
        },
        {
          value: "assessor",
          label: "Assessor",
        },
      ],
    }),
  };
};

export const ClientFormItemRows = ({
  user,
  client,
  assessores,
  professionals,
  handleChangeAssessores,
  onBlur,
  userSelected,
}: ClientFormItemProps) => {
  if (client)
    client.planType =
      client.planDueDate < new Date().getTime() ? "free" : client.planType;
  const formItems = FormItemsClients({
    user,
    client,
    assessores,
    professionals,
    handleChangeAssessores,
    onBlur,
  });
  const ret = [];
  ret.push([formItems.id]);
  ret.push([formItems.username]);
  ret.push([formItems.name]);
  ret.push([formItems.email]);
  ret.push([formItems.phone]);
  ret.push(
    ...(user?.user?.office || user?.user?.admin ? [[formItems.assessores]] : [])
  );
  return ret;
};

export const AssessorFormItemRows = (step: number, client?: IClient | null) => [
  [FormItemsAssessores(client).id],
  [FormItemsAssessores(client).username],
  [FormItemsAssessores(client).name],
  [FormItemsAssessores(client).email],
  [FormItemsAssessores(client).acesso],
];
